import React from 'react';
import { Icon } from '../Icon';
import './Preloader.css';

interface PreloaderProps {
  message?: string;
}

export const Preloader: React.FC<PreloaderProps> = ({ message = 'Загрузка...' }) => {
  return (
    <div className="preloader">
      <div className="preloader__content">
        {/* Анимированный логотип или иконка */}
        <div className="preloader__icon-wrapper">
          <div className="preloader__icon">
            <Icon name="wallet" size={48} />
          </div>
          <div className="preloader__ripple preloader__ripple--1"></div>
          <div className="preloader__ripple preloader__ripple--2"></div>
          <div className="preloader__ripple preloader__ripple--3"></div>
        </div>
        
        {/* Текст загрузки */}
        <div className="preloader__text">{message}</div>
        
        {/* Анимированные точки */}
        <div className="preloader__dots">
          <span className="preloader__dot"></span>
          <span className="preloader__dot"></span>
          <span className="preloader__dot"></span>
        </div>
      </div>
    </div>
  );
};

